$(function () {
    initActiveAnchors();
	$(document).on('click', function (e) {
		if ($(e.target).closest('.agreement__nav-section-header').length) {
			$('.agreement__nav').toggleClass('mobile-open');
		} else {
			$('.agreement__nav').removeClass('mobile-open');
		}
	});
});


function initActiveAnchors() {
    let anchors  = document.querySelectorAll('.agreement__nav-anchor');
    let headings = document.querySelectorAll('.typo h2[id]');
    if (!anchors.length || !headings.length) return;

    headings = Array.prototype.slice.call(headings);
    anchors  = Array.prototype.slice.call(anchors);

    let forcedId    = null;
    let forcedTimer = null;

    anchors.forEach(function (a) {
        a.addEventListener('click', function () {
            forcedId = (a.getAttribute('href') || '').replace('#', '');
            clearTimeout(forcedTimer);
            forcedTimer = setTimeout(function () { forcedId = null; render(); }, 2000);
        });
    });

    window.addEventListener('scroll', function () {
        if (forcedId) {
            clearTimeout(forcedTimer);
            forcedTimer = setTimeout(function () { forcedId = null; render(); }, 150);
        } else {
            render();
        }
    }, { passive: true });

    function render() {
        let threshold = window.innerHeight / 2;
        let vpH       = window.innerHeight;
        let activeId  = forcedId;

        if (!activeId) {
            for (let i = 0; i < headings.length; i++) {
                let top = headings[i].getBoundingClientRect().top;
                if (top >= 0 && top <= threshold) { activeId = headings[i].id; break; }
            }
        }

        if (!activeId) {
            for (let j = headings.length - 1; j >= 0; j--) {
                if (headings[j].getBoundingClientRect().top <= threshold) { activeId = headings[j].id; break; }
            }
        }

        if (!activeId && headings.length > 0) {
            let ft = headings[0].getBoundingClientRect().top;
            if (ft >= 0 && ft < vpH) activeId = headings[0].id;
        }

        anchors.forEach(function (a) {
            let href = a.getAttribute('href') || '';
            a.classList.toggle('is-active', href === '#' + activeId);
        });
    }

    render();
}
